import router from "../../router";

import rentObjectsService from "@/services/rentObjectsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await rentObjectsService.create(formData);
      dispatch(
        "common/showSuccess",
        `Objekt #${res.data.id} wurde erfolgreich angelegt.`,
        { root: true }
      );
      router.push({ name: "DataRentObjectEdit", params: { id: res.data.id } });
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekt konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async copy({ dispatch }, formData) {
    try {
      await rentObjectsService.copy(formData);
      dispatch(
        "common/showSuccess",
        "Daten wurden erfolgreich kopiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Daten konnten nicht kopiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async paste({ dispatch }, formData) {
    try {
      await rentObjectsService.paste(formData);
      dispatch(
        "common/showSuccess",
        "Daten wurden erfolgreich eingefügt.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Daten konnten nicht eingefügt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await rentObjectsService.findAll();
      commit("setAllRentObjects", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekte konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAllWithChannel({ commit, dispatch }) {
    try {
      const res = await rentObjectsService.findAllWithChannel();
      commit("setAllRentObjects", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekte konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async search({ dispatch }, searchString) {
    try {
      const res = await rentObjectsService.search(searchString);
      // commit("setAllRentObjects", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekte konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id, noSave }) {
    if (!noSave) {
      commit("setSingleRentObject", null);
    }
    try {
      const res = await rentObjectsService.findOne({ id });
      if (!noSave) {
        commit("setSingleRentObject", res.data);
      }
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekt konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findByIdForBookingCalendar({ commit, dispatch }, { id }) {
    commit("setSingleRentObject", null);
    try {
      const res = await rentObjectsService.findByIdForBookingCalendar({ id });
      commit("setSingleRentObject", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekt konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectsService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekt konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, { id, formData }) {
    try {
      await rentObjectsService.update({ id, formData });
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Mietobjekt wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjekt konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateOrder({ dispatch }, formData) {
    try {
      await rentObjectsService.updateOrder(formData);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Reihenfolge konnte nicht aktualisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async statistics({ dispatch }, formData) {
    try {
      const res = await rentObjectsService.statistics(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Mietobjektstatistik konnte nicht geladen werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
  getByRentObjectTypeId: (state) => (id) => {
    return state.all.filter(type => type.rentObjectTypeId == id)
  },
};

const mutations = {
  setAllRentObjects(state, object) {
    state.all = object;
  },
  setSingleRentObject(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
